import { NavLink } from 'react-router-dom';

interface BottomNavItem {
  path: string;
  label: string;
  icon: React.ComponentType<{ size?: number }>;
  end?: boolean;
}

interface BottomNavProps {
  items: BottomNavItem[];
}

export default function BottomNav({ items }: BottomNavProps) {
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-neutral-200 pb-[env(safe-area-inset-bottom)]">
      <div className="flex">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center gap-0.5 py-2 text-[11px] transition-colors ${
                  isActive
                    ? 'text-black font-medium'
                    : 'text-neutral-400'
                }`
              }
            >
              <Icon size={20} />
              <span className="truncate max-w-16">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
